import PropTypes from "prop-types";
import { Box, Divider, Stack, Tooltip, Typography } from "@mui/material";
import { getDatumZeit } from "../../services/formatService.js";
import DsButton from "../../theme/components/Button.jsx";
import { DetailField, MultilineText } from "./DetailViewComponents.jsx";

export default function NoteDetailView({ note, onClose }) {
  if (!note) return null;

  const { betreff, beschreibung, created_by, created_at } = note;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, pt: 1 }}>
      <Stack direction="row" spacing={1.5} flexWrap="wrap" alignItems="center">
        {created_by && (
          <Typography variant="caption" color="text.secondary">
            Erstellt von {created_by.vorname} {created_by.nachname}
          </Typography>
        )}
        {created_at && (
          <Typography variant="caption" color="text.secondary">
            {getDatumZeit(created_at)}
          </Typography>
        )}
      </Stack>

      <Divider />

      {/* Subject */}
      <Tooltip title={"Betreff"}>
        <Typography variant="h3">{betreff}</Typography>
      </Tooltip>

      <Box sx={{ maxWidth: "90ch" }}>
        <MultilineText value={beschreibung} />
      </Box>

      <Box sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}>
        <DsButton variant="tertiary" onClick={onClose}>
          Schließen
        </DsButton>
      </Box>
    </Box>
  );
}

NoteDetailView.propTypes = {
  note: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};
